import { FC, HTMLAttributes, ReactNode } from "react";
import classNames from "classnames";
import { SorterButtonField, SorterLabel } from "./SorterButton";

const SORTER_COMPONENTS = {
  sorterButton: SorterButtonField,
};

const Sorters: FC<{
  dataGroups: Map<string, Map<number | string, any[]>>;
  sorters: any[];
  activeSorter: string;
  isLoading?: boolean;
  computeLabels: (group: Map<string | number, any[]>, sorter: any) => { minLabel: SorterLabel | null; maxLabel: SorterLabel | null };
  renderLabel?: (label: SorterLabel | null) => ReactNode;
} & HTMLAttributes<HTMLDivElement>> = ({
  dataGroups,
  sorters,
  activeSorter,
  isLoading,
  computeLabels,
  className,
  renderLabel,
  ...props
}) => {
  return sorters.map((sorter, index) => {
    const group = dataGroups.get(sorter.key);

    if (!group || group.size === 0) return null;

    const Component = SORTER_COMPONENTS[sorter.component as keyof typeof SORTER_COMPONENTS];

    if (!Component) return null;

    const labels = computeLabels(group, sorter);

    return (
      <div
        key={sorter.key}
        className={classNames(
          "flex flex-1 items-center justify-center bg-background-default p-2 outline transition-all duration-300",
          index === 0 && "rounded-s-sm",
          index === sorters.length - 1 && "rounded-e-sm",
          activeSorter === sorter.key
            ? "z-10 border-border-active! text-font-active"
            : "z-0 outline-border-default",
          className,
        )}
        {...props}
      >
        <Component valuesMap={group} sorter={sorter} isLoading={isLoading} labels={labels} renderLabel={renderLabel ?? (() => null)} />
      </div>
    );
  });
};

export default Sorters;
